import { Experiment } from '@ms/yammer-data/dist/state/types';
import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useAndReportExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type UseBackButtonProps = () => {
  readonly goBack: () => void;
  readonly showButton: boolean;
};

const rootPaths = [
  /^\/admin\/?$/,
  /^\/discover-groups\/explore((\/\w+)+|\/?)$/,
  /^\/feed((\/\w+)+|\/?)$/,
  /^\/inbox((\/\w+)+|\/?)$/,
  /^\/leaders\/?$/,
  /^\/leadership-corner((\/\w+)+|\/?)$/,
  /^\/storylines((\/\w+)+|\/?)$/,
  /^\/questions\/?$/,
  /^\/user-settings((\/\w+)+|\/?)$/,
];

export const useBackButtonProps: UseBackButtonProps = () => {
  const history = useHistory();
  const location = useLocation();
  const [showButton, setShowButton] = useState(false);
  const isBackButtonEnabled = useAndReportExperimentTreatment(Experiment.BackButton) === true;

  const goBack = useCallback(() => {
    reportUsage({
      eventName: AnalyticsEventName.VivaEngageBackButtonClicked,
      eventProperties: { backFrom: window.location.href },
    });
    history.goBack();
  }, [history]);

  useEffect(() => {
    if (!isBackButtonEnabled) {
      return;
    }

    const path = location.pathname;
    if (rootPaths.some((rootPath) => rootPath.test(path))) {
      setShowButton(false);
    } else {
      setShowButton(true);
    }
  }, [location, isBackButtonEnabled]);

  return {
    goBack,
    showButton,
  };
};
